<template>
  <div class="global_header">
    <div class="layout-content_title">
      <a-breadcrumb>
        <template v-for="item in getListBreadcrumb">
          <a-breadcrumb-item v-if="item.title" :key="item.path">
            <router-link :to="`${item.path}`">{{ item.title }}</router-link>
          </a-breadcrumb-item>
        </template>
      </a-breadcrumb>
    </div>
    <div :class="wrpCls">
      <avatar-dropdown :menu="showMenu" :current-user="currentUser" :class="prefixCls" />
    </div>
  </div>
</template>

<script>
  import AvatarDropdown from './avatar-dropdown'

  export default {
    name: 'right-content',
    components: {
      AvatarDropdown,
    },
    props: {
      prefixCls: {
        type: String,
        default: 'ant-pro-global-header-index-action',
      },
      isMobile: {
        type: Boolean,
        default: () => false,
      },
      topMenu: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        breadcrumb: [],
        showMenu: true,
        currentUser: {},
      }
    },
    created() {
      this.setBreadcrumb(this.$route)
    },
    computed: {
      wrpCls() {
        return {
          'ant-pro-global-header-index-right': true,
          [`ant-pro-global-header-index-light`]: true,
        }
      },
      getListBreadcrumb() {
        return this.$store.getters.getListBreadcrumb
      },
    },
    methods: {
      /**
       * 设置显示标题
       * @param route
       */
      setBreadcrumb(route) {},
    },
    mounted() {
      setTimeout(() => {
        this.currentUser = JSON.parse(window.sessionStorage.getItem('userInfo')) ?? {}
      }, 1500)
    },
    watch: {
      getListBreadcrumb: {
        handler(newVal, oldVal) {},
      },
    },
  }
</script>
<style lang="scss" scoped>
  .ant-pro-global-header-index-light {
    float: right;
    height: 100%;
    overflow: hidden;
    margin-right: 20px;
  }

  .layout-content_title {
    float: left;
    height: 100%;
    background-color: #fff;

    .ant-breadcrumb {
      line-height: 64px;
      margin-left: 20px;
    }
  }
</style>
